import Section_Mobile from "./Section_Mobile";

function MobileMenu({ menuPages = [], menuSections = [] }) {
  
  function toggleMobileMenuOpen() {
    let menu = document.getElementById("menu-mobile");
    if (menu.classList.contains("closed")) {
      menu.classList.remove("closed");
      menu.classList.add("open");
    } else {
      menu.classList.remove("open");
      menu.classList.add("closed");
    }
  }

  return (
    <>
      <div id="menu-mobile" className="menu closed print-hidden">
        <span
          id="close-mobile"
          className="material-symbols-outlined"
          onClick={() => toggleMobileMenuOpen()}
        >
          close
        </span>
      {menuSections
        .filter((y) => y.Pages)
        .map((x) => (
          <div key={x.id}>
            <Section_Mobile
              sectionTitle={x.name}
              pages={menuPages.filter((z) => 
                z.section === x.name && !z.urlPath.includes(':')
              )}
            allSectionNames = {menuSections.map((x)=>x.name)}
            />
          </div>
        ))}
      </div>
    </>
  );
}

export default MobileMenu;